import { PropsWithChildren, useCallback } from 'react';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import SupplierCard, {
  ISharedTypes as ISupplierCardProps,
} from '@bridebook/web/app-shared/components/supplier/supplier-card/supplier-card';
import { ShortlistedLocation } from '@bridebook/web/lib/shortlist/types';
import SupplierInfoCardContent from './supplier-info-card-content';

interface SupplierInfoCardProps extends ISupplierCardProps, PropsWithChildren {
  supplier: IUISupplier;
  showDetailsTags?: boolean;
  minified?: boolean;
  showAdditionalImages?: boolean;
  contact?: boolean;
  onClick: (location?: ShortlistedLocation) => void;
  market: Market;
}

const SupplierInfoCard = ({
  supplier,
  showBudgetMatch,
  shortlistedLocation,
  children,
  onClick,
  market,
  ...props
}: SupplierInfoCardProps) => {
  const supplierCardOnClick = useCallback(
    () => onClick(shortlistedLocation),
    [shortlistedLocation, onClick],
  );

  return (
    <SupplierCard
      {...props}
      supplier={supplier}
      showBudgetMatch={showBudgetMatch}
      shortlistedLocation={shortlistedLocation}
      supplierCardOnClick={supplierCardOnClick}>
      <SupplierInfoCardContent {...props} market={market} supplier={supplier} />
      {children}
    </SupplierCard>
  );
};

export default SupplierInfoCard;
